document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-xv-menu-toggle]');
  const menu = document.querySelector('[data-xv-menu]');
  const backdrop = document.querySelector('[data-xv-menu-backdrop]');
  if (toggle && menu) {
    const setMenu = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      menu.classList.toggle('is-open', open);
      document.body.classList.toggle('xv-menu-open', open);
      if (backdrop) backdrop.hidden = !open;
    };
    toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
    if (backdrop) backdrop.addEventListener('click', () => setMenu(false));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });
  }

  const inquiry = document.querySelector('[data-xv-inquiry]');
  if (inquiry) {
    const inquiryToggle = inquiry.querySelector('[data-xv-inquiry-toggle]');
    const inquiryClose = inquiry.querySelector('[data-xv-inquiry-close]');
    const panel = inquiry.querySelector('.xv-inquiry__panel');
    const setInquiry = (open) => {
      inquiryToggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (open) panel.querySelector('input,textarea,select')?.focus({ preventScroll: true });
    };
    inquiryToggle.addEventListener('click', () => setInquiry(inquiryToggle.getAttribute('aria-expanded') !== 'true'));
    inquiryClose.addEventListener('click', () => setInquiry(false));
    document.querySelectorAll('[data-xv-inquiry-open]').forEach((button) => button.addEventListener('click', () => setInquiry(true)));
  }

  const updateViewport = () => document.documentElement.style.setProperty('--xv-vh', `${(window.visualViewport?.height || window.innerHeight) * 0.01}px`);
  updateViewport();
  window.visualViewport?.addEventListener('resize', updateViewport);

  document.querySelectorAll('[data-xv-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-xv-main-image]');
      const image = button.querySelector('img');
      if (target && image) {
        target.src = button.dataset.xvImage || image.currentSrc || image.src;
        target.dataset.xvFullImage = button.dataset.xvFullImage || target.src;
        target.alt = image.alt;
        const counter = document.querySelector('[data-xv-media-counter]');
        if (counter) counter.textContent = `${button.dataset.xvIndex || '1'} / ${document.querySelectorAll('[data-xv-thumb]').length || '1'}`;
        document.querySelectorAll('[data-xv-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      }
    });
  });

  const thumbTrack = document.querySelector('[data-xv-thumbs]');
  if (thumbTrack) {
    const moveThumbs = (direction) => thumbTrack.scrollBy({ left: direction * Math.max(thumbTrack.clientWidth * .82, 240), behavior: 'smooth' });
    document.querySelector('[data-xv-thumbs-prev]')?.addEventListener('click', () => moveThumbs(-1));
    document.querySelector('[data-xv-thumbs-next]')?.addEventListener('click', () => moveThumbs(1));
  }
  const relatedTrack = document.querySelector('[data-xv-related-track]');
  if (relatedTrack) {
    const moveRelated = (direction) => relatedTrack.scrollBy({ left: direction * Math.max(relatedTrack.clientWidth * .78, 280), behavior: 'smooth' });
    document.querySelector('[data-xv-related-prev]')?.addEventListener('click', () => moveRelated(-1));
    document.querySelector('[data-xv-related-next]')?.addEventListener('click', () => moveRelated(1));
  }
  const stickyPurchase = document.querySelector('.xv-sticky-purchase');
  const primaryPurchase = document.querySelector('[data-xv-primary-purchase]');
  if (stickyPurchase && primaryPurchase && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => stickyPurchase.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(primaryPurchase);
  }

  const lightbox = document.querySelector('[data-xv-lightbox]');
  const lightboxOpen = document.querySelector('[data-xv-lightbox-open]');
  const lightboxClose = document.querySelector('[data-xv-lightbox-close]');
  const lightboxImage = document.querySelector('[data-xv-lightbox-image]');
  if (lightbox && lightboxOpen && lightboxClose && lightboxImage) {
    const closeLightbox = () => lightbox.open && lightbox.close();
    lightboxOpen.addEventListener('click', () => {
      const current = document.querySelector('[data-xv-main-image]');
      if (!current) return;
      lightboxImage.src = current.dataset.xvFullImage || current.currentSrc || current.src;
      lightboxImage.alt = current.alt;
      lightbox.showModal();
    });
    lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
  }

  const countryDialog = document.querySelector('[data-xv-country-dialog]');
  const countryOpen = document.querySelector('[data-xv-country-open]');
  const countryClose = document.querySelector('[data-xv-country-close]');
  const countrySearch = document.querySelector('[data-xv-country-search]');
  const countryList = document.querySelector('[data-xv-country-list]');
  const countryValue = document.querySelector('[data-xv-country-value]');
  const countrySelected = document.querySelector('[data-xv-country-selected]');
  const countryEmpty = document.querySelector('[data-xv-country-empty]');
  if (countryDialog && countryOpen && countryClose && countryList && countryValue) {
    const closeCountry = () => countryDialog.open && countryDialog.close();
    countryOpen.addEventListener('click', () => {
      countryDialog.showModal();
      countrySearch?.focus({ preventScroll: true });
    });
    countryClose.addEventListener('click', closeCountry);
    countryDialog.addEventListener('click', (event) => { if (event.target === countryDialog) closeCountry(); });
    countryList.querySelectorAll('[data-xv-country-option]').forEach((option) => {
      option.addEventListener('click', () => {
        countryList.querySelectorAll('[data-xv-country-option]').forEach((item) => {
          const selected = item === option;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-selected', String(selected));
          item.querySelector('em')?.remove();
        });
        option.lastElementChild?.insertAdjacentHTML('beforeend', '<em>Selected</em>');
        countryValue.value = option.dataset.countryCode;
        if (countrySelected) countrySelected.textContent = option.querySelector('strong')?.textContent || option.dataset.countryCode;
      });
    });
    countrySearch?.addEventListener('input', () => {
      const query = countrySearch.value.trim().toLocaleLowerCase();
      let matches = 0;
      countryList.querySelectorAll('[data-xv-country-option]').forEach((option) => {
        const match = !query || option.dataset.countrySearch.toLocaleLowerCase().includes(query);
        option.hidden = !match;
        if (match) matches += 1;
      });
      if (countryEmpty) countryEmpty.hidden = matches > 0;
      countryList.hidden = matches === 0;
    });
  }

  const footerGroups = document.querySelectorAll('.xv-footer__group');
  const syncFooterGroups = () => footerGroups.forEach((group) => {
    if (window.matchMedia('(max-width: 749px)').matches) group.removeAttribute('open');
    else group.setAttribute('open', '');
  });
  if (footerGroups.length) {
    syncFooterGroups();
    window.matchMedia('(max-width: 749px)').addEventListener?.('change', syncFooterGroups);
  }
});
